module.exports = __webpack_public_path__ + "19f52b79.jpg";